import _regeneratorRuntime from "/codebuild/output/src386676321/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(runRequestSignOut),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleRequestSignOut),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(runCompleteSignOut),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleCompleteSignOut),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(rootSagas);

import { call, fork, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions/signOut';
import { signOut } from '../models/signOut';
import { requestResetUser } from '..';
export function runRequestSignOut() {
  return _regeneratorRuntime.wrap(function runRequestSignOut$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(signOut);

        case 2:
          _context.next = 4;
          return put(actions.completeSignOut());

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function handleRequestSignOut() {
  return _regeneratorRuntime.wrap(function handleRequestSignOut$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(actions.requestSignOut.type, runRequestSignOut);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function runCompleteSignOut() {
  return _regeneratorRuntime.wrap(function runCompleteSignOut$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(requestResetUser());

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
export function handleCompleteSignOut() {
  return _regeneratorRuntime.wrap(function handleCompleteSignOut$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(actions.completeSignOut.type, runCompleteSignOut);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export default function rootSagas() {
  return _regeneratorRuntime.wrap(function rootSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(handleRequestSignOut);

        case 2:
          _context5.next = 4;
          return fork(handleCompleteSignOut);

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}